import { css } from '@emotion/react';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { AiFillSetting } from 'react-icons/ai';
import { Accordion } from 'react-bootstrap';
import OurAccordionMultiple from '@/_elements/OurAccordionMultiple';
import { BootstrapToolTip, ConsentToolTip } from '@/_elements/ToolTip';
import { Checkbox } from '@/_elements/FormElements';
import { LoadingSpinner } from '@/_elements/Loaders';
import { fetchWrapper } from '@/_helpers';
import { toast } from 'react-toastify';
import { VscLoading } from 'react-icons/vsc';
function isObject(item) {
    return typeof item === 'object' && !Array.isArray(item) && item !== null;
}
const FormSettings = React.memo(({ formId }) => {
    const [show, setShow] = useState(false);
    const [activeKey, setActiveKey] = useState('fill');
    const [settings, setSettings] = useState({});
    const [isBusy, setIsBusy] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const handleSave = async () => {
        try {
            setIsBusy(true);
            await fetchWrapper.put(`forms/${formId}/settings`, { settings });
        } catch (error) {
            if (error?.name === 'AbortError') {
                return;
            }
            console.log('error', error);
            toast.error(error.message);
        } finally {
            setIsBusy(false);
        }
    };
    const fetchFormSettings = async () => {
        try {
            setIsBusy(true);
            const _settings = (await fetchWrapper.get(`forms/${formId}/settings`)) || {};
            setSettings(isObject(_settings) ? _settings : {});
        } catch (error) {
            if (error?.name === 'AbortError') {
                return;
            }
            toast.error(error.message);
        } finally {
            setIsBusy(false);
        }
    };
    useEffect(() => {
        if (formId && show) {
            fetchFormSettings();
        }
    }, [formId, show]);

    return (
        <Fragment>
            <BootstrapToolTip text="Form Settings">
                <AiFillSetting color="orange" size={24} onClick={handleShow} className=" icon edit" />
            </BootstrapToolTip>
            <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered size="xl">
                <Modal.Header closeButton>
                    <div
                        css={css`
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                        `}
                    >
                        <h3
                            css={css`
                                font-weight: 600;
                                margin-right: 1rem;
                            `}
                            className="text-capitalize"
                        >
                            <AiFillSetting color="orange" size={24} />
                            <span className="ml-2">Form Settings</span>
                        </h3>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {isBusy ? (
                        <LoadingSpinner size={64} height={200} />
                    ) : (
                        <Fragment>
                            <Accordion
                                defaultActiveKey={activeKey}
                                onSelect={(e) => {
                                    setActiveKey(e);
                                }}
                            >
                                <OurAccordionMultiple
                                    title={'Fill Form'}
                                    eventKey={'fill'}
                                    isOpen={activeKey === 'fill'}
                                    titleTag=""
                                >
                                    <div className="d-flex flex-column">
                                        <div className="d-flex flex-row">
                                            <ConsentToolTip
                                                text="Allow last submission data from channel as a fallback if user has not submitted yet"
                                                className="mr-2"
                                            />
                                            <Checkbox
                                                label={'Enable Channel Last Submission Fill'}
                                                value={!!settings?.enableChannelLastSubmissionPopulate}
                                                onChange={(checked) => {
                                                    setSettings((prev) => ({
                                                        ...settings,
                                                        enableChannelLastSubmissionPopulate: checked,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                </OurAccordionMultiple>
                            </Accordion>
                        </Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSave} disabled={isBusy}>
                        {isBusy && <VscLoading className="spin mr-2" />}
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
});
export default FormSettings;
